// 事件行銷獎勵發放紀錄操作日誌常數

// 操作動作（label 為動詞形式，用於 timeline title 顯示）
export const awardRecordLogActionConfig = {
  sent: { label: '發放', stepStatus: 'finish' },
  sendFailed: { label: '發放失敗', stepStatus: 'error' },
  revoked: { label: '回收', stepStatus: 'error' },
  revokeFailed: { label: '回收失敗', stepStatus: 'error' },
}

// 獎勵類型單位
export const awardTypeUnitConfig = {
  cashback: '元',
  classTicket: '張',
  coupon: '張',
  point: '點',
}

// 操作來源
export const awardRecordLogOriginConfig = {
  system: { label: '系統自動' },
  user: { label: '手動回收' },
}

// 觸發類型
export const awardRecordLogOriginTypeConfig = {
  transactionVoided: { label: '交易作廢' },
  transactionReturned: { label: '交易退貨' },
}
